import { DefaultGuardRequest } from './DefaultGuardRequest';
var Guard = /** @class */ (function () {
    function Guard(guardModel, policyList, subject) {
        var _this = this;
        this.guardModel = guardModel;
        this.policyList = policyList;
        this.subject = subject;
        this.can = function (resourceName, action) {
            var _a, _b;
            return ((_b = (_a = _this.guardModel) === null || _a === void 0 ? void 0 : _a.effect(_this.createRequest(resourceName, action), _this.policyList || [])) !== null && _b !== void 0 ? _b : true);
        };
        this.createRequest = function (resourceName, action) {
            return new DefaultGuardRequest(_this.subject, resourceName, action);
        };
    }
    return Guard;
}());
export { Guard };
//# sourceMappingURL=Guard.js.map